// lib/edition/edition.ts
//
// Edición del build en el frontend, leída de `import.meta.env.VITE_EDITION`
// (la inyecta Vite; ver prepare-onprem.ts y .env.example). Default "saas".
// Espejo client-side de `EDITION` del backend (convex/lib/config/core.ts).

import { EDITION } from "@/convex/lib/config/core";

export type Edition = "saas" | "desktop" | "onprem" | "free_desktop";

export function getEdition(): Edition {
  const raw = EDITION;
  return raw === "onprem" || raw === "desktop" || raw === "free_desktop"
    ? raw
    : "saas";
}

export function isOnPremEdition(): boolean {
  return getEdition() === "onprem";
}

/** Edición free de escritorio (instalador local gratis, backend embebido). */
export function isFreeDesktopEdition(): boolean {
  return getEdition() === "free_desktop";
}

/**
 * Instalación local self-host (onprem o free_desktop): comparten gate de
 * licencia, onboarding desde token, single-tenant y bootstrap del primer admin.
 * Usar esto (no `isOnPremEdition()`) para la lógica común a ambas.
 */
export function isLocalInstallEdition(): boolean {
  const e = getEdition();
  return e === "onprem" || e === "free_desktop";
}
